import { useTheme } from "@emotion/react";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import useCustomStyles from "../hooks/CustomStylesHook";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const styles = (theme: any) => ({
  cellRenderMainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  eyeIcon: {
    cursor: "pointer",
    marginRight: "10px",
    fontSize: "20px",
  },
  deleteIcon: {
    cursor: "pointer",
    fontSize: "20px",
  },
});

export const ActionCellRenderer = (params: any) => {
  const { data, context } = params;
  const { onPreview, onDelete } = context;
  const theme = useTheme();
  const classes = useCustomStyles(styles, theme);

  return (
    <div className={classes?.cellRenderMainContainer}>
      <VisibilityOutlinedIcon
        className={classes?.eyeIcon}
        color="primary"
        onClick={() => onPreview(data?.id)}
      />
      <DeleteOutlineOutlinedIcon
        className={classes?.deleteIcon}
        color="error"
        onClick={() => onDelete(data?.id)}
      />
    </div>
  );
};

export const RewriteActionCellRenderer = (params: any) => {
  const { data, context } = params;
  const { onEdit, onDelete } = context;
  const theme = useTheme();
  const classes = useCustomStyles(styles, theme);

  return (
    <div className={classes?.cellRenderMainContainer}>
      <EditOutlinedIcon
        className={classes?.eyeIcon}
        color="primary"
        onClick={() => onEdit(data)}
      />
      <DeleteOutlineOutlinedIcon
        className={classes?.deleteIcon}
        color="error"
        onClick={() => onDelete(data)}
      />
    </div>
  );
};

export const EmailActionCellRenderer = (params: any) => {
  const { data, context } = params;
  const { onEdit } = context;
  const theme = useTheme();
  const classes = useCustomStyles(styles, theme);

  return (
    <div className={classes?.cellRenderMainContainer}>
      <EditOutlinedIcon
        className={classes?.eyeIcon}
        color="primary"
        onClick={() => onEdit(data)}
      />
    </div>
  );
};
